<template>
  <Layout>


    <div class="rwt-portfolio-area rn-section-gap" style="padding-top:25px !important;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                text-align="center"
                data-aos="fade-up"
                data-aos-delay="60"
            />
          </div>
        </div>
        <Product class="mt--20" :products="products" column="col-lg-4 col-md-6 mt--30"/>
      </div>
    </div>
  </Layout>
</template>


<script>
import Product from '@/components/elements/product/Product'
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
import Layout from '@/components/common/Layout'
import site from '@/data/site.json'

export default {
  name: 'ProductPage',
  components: { Product, SectionTitle, Layout },
  data() {
    return { products: site.products }
  }
}
</script>
